import styled from 'styled-components';
import QuizWidget from '../../../components/Cards/QuizWidget';

const Container = styled.div`
  padding: 24px 14px 70px;
  min-height: calc(100vh - 70px);
`;

const PageTitle = styled.h1`
  font-size: 20px;
  font-weight: 900;
  color: #fff;
  margin: 0 0 4px;
`;

const PageSub = styled.p`
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
  margin: 0 0 20px;
`;

const QuizMobile: React.FC = () => (
  <Container>
    <PageTitle>Quiz GWF</PageTitle>
    <PageSub>Rispondi correttamente per guadagnare crediti. Hai 15 secondi.</PageSub>
    <QuizWidget />
  </Container>
);

export default QuizMobile;
